// src/pages/account/articles/BookmarkArticle.js
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../../../shared/libs/firebaseConfig";
import {
  collection,
  getDocs,
  doc as fsDoc,
  getDoc,
} from "firebase/firestore";
import { useAuth } from "../../../shared/hooks/useAuth";

import { useNavigate } from "react-router-dom";

import { BsClock } from "react-icons/bs";

// ถ้าใช้ icon เหมือน MyArticle
import openai_icon from "../../../assets/openai_icon.png";
import gemini_icon from "../../../assets/gemini_icon.png";
import n8n_icon from "../../../assets/n8n_icon.png";
import midjourney from "../../../assets/midjourney_icon.png";
import perplexity from "../../../assets/perplexity_icon.png";



// 1) brandKey -> icon
const BRAND_ICON_MAP = {
  openai: openai_icon,
  gemini: gemini_icon,
  n8n: n8n_icon,
  midjourney: midjourney,
  perplexity: perplexity,
 /*  googlesheets: Logo_Encraft_01,
  org: Logo_Encraft_02, */
};

// 2) slug -> brandKey
const SLUG_TO_BRAND_KEY = {
  chatgpt: "openai",
  openai: "openai",
  gemini: "gemini",
  n8n: "n8n",
  midjourney: "midjourney",
  perplexity: "perplexity",
  /* googlesheets: "Logo_Encraft_01",
  org: "Logo_Encraft_02", */
};

// 3) brandKey -> คำค้นที่จะส่งไปหน้า search
//   จะใช้คำเดียวกับ brandKey ก็ได้ หรือจะกำหนดเองแบบนี้ก็ได้
const BRAND_SEARCH_TERM = {
  openai: "chatgpt",   // ถ้าอยากให้ค้นด้วยคำว่า chatgpt
  gemini: "gemini",
  n8n: "n8n",
  midjourney: "midjourney",
  perplexity: "perplexity",
 /*  googlesheets: "Logo_Encraft_01",
  org: "Logo_Encraft_02", */
};


const getSearchTermForBrand = (brandKey) =>
  BRAND_SEARCH_TERM[brandKey] || brandKey;

const BookmarkArticleCard = ({ article }) => {

    const navigate = useNavigate();

    const aiBrandKeys = Array.from(
        new Set(
        (article.tagSlugs || [])
            .map((slug) => slug.toLowerCase())
            .map((slug) => SLUG_TO_BRAND_KEY[slug])  // แปลงเป็น brandKey
            .filter(Boolean)                         // ตัดตัวที่ map ไม่ได้ทิ้ง
        )
    );

  
    const handleClickBrand = (e, brandKey) => {
        e.preventDefault();      // กันไม่ให้ลิงก์การ์ดทำงาน
        e.stopPropagation();     // กัน bubbling ไป Link ด้านนอก
        const term = getSearchTermForBrand(brandKey);
        navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    const handleClickLevel = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const term = article.level?.toLowerCase() ?? "";
        if (term) navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    const handleClickCategory = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const term = (article.category || "").toLowerCase();
        if (term) navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    // 👇 ปุ่ม +N → ไปค้นคำว่า "ai tools"
    const handleClickMore = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const term = "ai tools";   // อยากเปลี่ยนคำค้นก็แก้ตรงนี้ได้เลย
        navigate(`/search?q=${encodeURIComponent(term)}`);
    };

    // ดึง tagSlugs -> brandKey -> unique
    const allBrandKeys = Array.from(
        new Set(
            (article.tagSlugs || [])
            .map((slug) => slug.toLowerCase())
            .map((slug) => SLUG_TO_BRAND_KEY[slug])
            .filter(Boolean)
        )
    );

    // แบรนด์ที่จะแสดงเป็นไอคอนจริง ๆ (สูงสุด 3)
    const firstBrandKeys = allBrandKeys.slice(0, 3);

    // จำนวนแบรนด์ที่เหลือเกินจาก 3
    const extraCount = allBrandKeys.length - firstBrandKeys.length;





  const authorName =
    typeof article.author === "object"
      ? article.author?.displayName ?? "-"
      : article.author ?? "-";

  /* const categoryName =
    typeof article.category === "object"
      ? article.category?.name ?? "-"
      : article.category ?? "-"; */

  const subCategoryName =
    typeof article.subCategory === "object"
      ? article.subCategory?.name ?? "-"
      : article.subCategory ?? "-";

  const coverSrc =
    article.cover ||
    article.cover?.src ||
    (Array.isArray(article.contentBlocks)
      ? article.contentBlocks.find((b) => b.type === "image")?.src
      : "") ||
    "https://placehold.co/800x450/png";

  const updated = article.updatedAt?.toDate
    ? article.updatedAt.toDate()
    : article.updatedAt || null;

    // ------- helper -------
    function formatThaiDate(date) {
      if (!date) return "";
      return date.toLocaleDateString("th-TH", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

  // 👇 ตรงนี้ให้เปลี่ยน path ให้ตรงกับหน้าอ่านบทความจริงของคุณ
  const articleLink = `/articles/${article.slug || article.id}`;

  return (
    <Link
      to={articleLink}
      className="text-decoration-none text-reset"
    >
      <div className="card article-card shadow-sm h-100">
        <div className="image-wrapper">
          <img
            src={coverSrc}
            className="card-img-top"
            alt={article.title || ""}
          />
        </div>

        <div className="card-body">
          <p className="card-meta">
            {/* <BsClock />{" "} */}
            {updated ? formatThaiDate(updated) : "-"}{" "}
            &nbsp;|&nbsp; {authorName}
          </p>

          <h5 className="articlename">{article.title || "-"}</h5>

          <div className="level-section">
            <span className="level-text">
              {article.level && (
                  <>
                    {article.level === "general"
                      ? "General"
                      : article.level === "beginner"
                      ? "Beginner"
                      : article.level === "intermediate"
                      ? "Intermediate"
                      : article.level === "advanced"
                      ? "Advanced"
                      : article.level}
                  </>
                )}
            </span>
            {(firstBrandKeys.length > 0 || extraCount > 0) && (
                <div className="level-icons">
                    {firstBrandKeys.map((brandKey) => (
                        <img
                        key={brandKey}
                        src={BRAND_ICON_MAP[brandKey]}
                        alt={brandKey}
                        className="level-icon"
                        role="button"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => handleClickBrand(e, brandKey)}
                        />
                    ))}

                    {extraCount > 0 && (
                        <span
                        className="level-icon-more"
                      /*  role="button"
                        style={{ cursor: "pointer" }}
                        onClick={handleClickMore} */
                        >
                        +{extraCount}
                        </span>
                    )}
                </div>
            )}
          </div>

          <div className="card-footer-section">
            <div className="left">
              {article.views != null && (
                <span className="text-secondary">
                  <span
                    className="badge-content-type"
                  >
                    {article.readTime || 0} min read
                  </span>{" "}
                  • {Number(article.views).toLocaleString()} views
                </span>
              )}
            </div>
            <div className="right">
              <span className="badge-content-type">{subCategoryName}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default function BookmarkArticle() {
  const { user } = useAuth();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [qtext, setQtext] = useState("");
  const [tag, setTag] = useState("");

  useEffect(() => {
    if (!user) return;
    loadBookmarks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const loadBookmarks = async () => {
    setLoading(true);
    try {
      // 1) ดึง doc id จาก users/{uid}/bookmarks
      const bmRef = collection(db, "users", user.uid, "bookmarks");
      const bmSnap = await getDocs(bmRef);
      const articleIds = bmSnap.docs.map((d) => d.id);

      if (articleIds.length === 0) {
        setItems([]);
        return;
      }

      // 2) ดึงข้อมูลบทความจริงจาก articles/{articleId}
      const articlePromises = articleIds.map((id) =>
        getDoc(fsDoc(db, "articles", id))
      );
      const articleSnaps = await Promise.all(articlePromises);

      const articles = articleSnaps
        .filter((s) => s.exists())
        .map((s) => ({ id: s.id, ...s.data() }));

      // จะ sort ตาม updatedAt ก็ได้
      articles.sort((a, b) => {
        const ta = a.updatedAt?.toMillis ? a.updatedAt.toMillis() : 0;
        const tb = b.updatedAt?.toMillis ? b.updatedAt.toMillis() : 0;
        return tb - ta;
      });

      setItems(articles);
    } finally {
      setLoading(false);
    }
  };

  // ค้นหาจาก title / slug + กรองแท็ก แบบ client-side
  const filtered = useMemo(() => {
    let list = items;

    if (qtext.trim()) {
      const t = qtext.trim().toLowerCase();
      list = list.filter(
        (x) =>
          (x.title || "").toLowerCase().includes(t) ||
          (x.slug || "").toLowerCase().includes(t)
      );
    }

    if (tag.trim()) {
      const t = tag.trim().toLowerCase();
      list = list.filter((x) => {
        const slugs = Array.isArray(x.tagSlugs) ? x.tagSlugs : [];
        const displays = Array.isArray(x.tagsDisplay) ? x.tagsDisplay : [];
        return (
          slugs.some((s) => s.toLowerCase().includes(t)) ||
          displays.some((s) => s.toLowerCase().includes(t))
        );
      });
    }

    return list;
  }, [items, qtext, tag]);

  return (
    <div className="container py-4">
      {/* หัวเรื่อง */}
      <div className="d-flex justify-content-between align-items-end gap-2 mb-2">
        <div>
          <h4 className="m-0">บทความที่บันทึกไว้</h4>
          <div className="small text-muted mt-1">
            ทั้งหมด {items.length} บทความ
          </div>
        </div>
      </div>

      {/* Toolbar ค้นหา/กรอง */}
      <div className="row g-2 align-items-center mb-3">
        {/* ค้นหา */}
        <div className="col-12 col-lg-8">
          <input
            className="form-control"
            // placeholder="ค้นหาจากชื่อ/สลัก (slug)"
            placeholder="ค้นหาจากชื่อบทความ"
            value={qtext}
            onChange={(e) => setQtext(e.target.value)}
          />
        </div>

        {/* แท็ก */}
        <div className="col-12 col-lg-4">
          <input
            className="form-control"
            placeholder="กรองแท็กบทความ เช่น เนติบัณฑิต"
            value={tag}
            onChange={(e) => setTag(e.target.value)}
          />
        </div>
      </div>

      {/* Grid แสดงบทความ */}
      {loading ? (
        <div className="text-muted">กำลังโหลด…</div>
      ) : filtered.length === 0 ? (
        <div className="text-muted">
          ยังไม่มีบทความที่บันทึกไว้ หรือไม่พบตามเงื่อนไขค้นหา
        </div>
      ) : (
        <div className="row g-3">
          {filtered.map((a) => (
            <div key={a.id} className="col-12 col-lg-6">
              <BookmarkArticleCard article={a} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}